/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { getHtmlByProductNumberAsync } from '../../actions/DataActionExtension.g';

import { IEcommCustomHtmlpageData } from './ecomm-custom-htmlpage.data';
import { IEcommCustomHtmlpageProps } from './ecomm-custom-htmlpage.props.autogenerated';

export interface IEcommCustomHtmlPageViewProps extends IEcommCustomHtmlpageProps<IEcommCustomHtmlpageData> {
    markup: string;
}

/**
 *
 * EshopCustomFaq component
 * @extends {React.PureComponent<IEshopCustomFaqProps<IEshopCustomFaqData>>}
 */
class EcommCustomHtmlPage extends React.PureComponent<IEcommCustomHtmlpageProps<IEcommCustomHtmlpageData>> {
    public state: any = { markup: '' };

    public async componentDidMount() {
      const { config } = this.props;
  
      let fileName = config.htmlFileName;
      let value = ''

      if (fileName) {
        value = `${fileName + '.html'}`;
      }
  
  
      if (this.state.markup === '' && value !== '') {
        const result = await getHtmlByProductNumberAsync({ callerContext: this.props.context.actionContext }, config.env, config.entity, config.containerName, value);
  
         // If not html given, contents are ""}.
         const contents = ((result && result !== '' && (!this._isTemplateProvided(JSON.stringify(result))))? result:'');
      
         if (contents) {
           this.setState({ markup: result });
         } else {
           this.setState({ markup: '' });
         }
       } else {
         this.setState({ markup: '' });
       }
    }
  
    private _isTemplateProvided= (str: string): boolean => {
      try {
        const parsedJSON = JSON.parse(str);
        const parse = parsedJSON && parsedJSON !== ''&& parsedJSON['value'] == ''?'TemplateNotProvided':'';
        if(!parse) {
          return false;
        }
      } catch (e) {
          return false;
      }
      return true;
    }
  
    public render(): JSX.Element | null {
      const EcommProductDescriptionView = {
        ...this.props,
        markup: this.state.markup
      }
  
      return this.props.renderView(EcommProductDescriptionView);
    }
}

export default EcommCustomHtmlPage;
